import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HierarchicalMenuComponent } from '../algolia/hierarchical-menu/hierarchical-menu.component';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HierarchicalMenuComponent],
})
export class SideNavComponent {}
